jQuery( function($) {
    $(document).ready( function() {

        if ($(".immunatuRNA-component").length > 0) {

            $('[three-elements-section]').each(function () {

                var swiper = new Swiper($(this).find('.swiper-container'), {

                    slidesPerView: 'auto',
                });

            });

            const swiper = new Swiper('.swiper', {
                speed: 400,
                spaceBetween: 100,
            });

        }

    });
});
